import React, { Component } from 'react';
import 'styled-components/macro';
import * as types from 'styled-components/cssprop'; /* eslint-disable-line */
import { css, withTheme, Theme } from 'styled-components';
import CloseButton from '../close-btn';
import { Context } from '../../i18n';
import { isRTL } from '@/utils/utils';
import { scale, isMobile } from '@/utils/constants';
const setRem = (base: number, target: number) => (base / 100) * (100 / target);

class VerifyBar extends Component<{
  answer_url: string;
  type: 'text' | '3d' | 'slide' | 'whirl' | 'icon' | 'voice';
  handleClose: (e: React.MouseEvent<HTMLElement>) => void;
  for_3d_bar_text: string;
  theme: Theme;
  lang: string;
  hideCloseBtn?: boolean;
}> {
  static contextType = Context;
  context!: React.ContextType<typeof Context>;
  render() {
    const {
      answer_url,
      handleClose,
      type,
      for_3d_bar_text,
      hideCloseBtn,
      lang,
    } = this.props;
    const {
      titleColor,
      titleTextSlide,
      titleTextWhirl,
      titleText3D,
      titleTextIcon,
      titleSize,
    } = this.props.theme;

    const {
      text_title_1 = '',
      slide_tip = '',
      text_title_whirl = '',
      H5_VerifyTips_14 = '',
    } = this.context;
    let content_dom = null;
    let padding_str = '0.16em 0.12em 0.08em';

    if (type === 'text') {
      const cont = text_title_1 + (text_title_1 ? ':' : '');
      content_dom = (
        <>
          <div>
            {cont}
            &nbsp;
          </div>
          <div
            css={css`
              vertical-align: middle;
              padding: 0 ${setRem(15, 17)}em 0 ${setRem(10, 17)}em;
              margin-top: -${setRem(2, 17)}em;
            `}
          >
            <img
              css={css`
                width: unset;
                height: ${setRem(16, 17)}em;
                vertical-align: middle;
              `}
              src={answer_url}
              alt=""
              id="verify-bar-code"
            />
          </div>
        </>
      );
    } else if (type === 'icon') {
      let con = H5_VerifyTips_14 + (H5_VerifyTips_14 ? ':' : '');
      if (titleTextIcon) {
        con = titleTextIcon + (titleTextIcon ? ':' : '');
      }
      content_dom = (
        <>
          <div>
            {con}
            &nbsp;
          </div>
          <div
            css={css`
              vertical-align: middle;
              padding: 0 ${setRem(15, 17)}em 0 ${setRem(10, 17)}em;
              margin-top: -${setRem(2, 17)}em;
            `}
          >
            <img
              css={css`
                width: unset;
                height: ${setRem(16, 8.88)}em;
                vertical-align: middle;
              `}
              src={answer_url}
              alt=""
              id="verify-bar-code"
            />
          </div>
        </>
      );
    } else if (type === '3d') {
      let cont = for_3d_bar_text + (for_3d_bar_text ? ':' : '');
      if (titleText3D) {
        cont = titleText3D + (titleText3D ? ':' : '');
      }

      content_dom = (
        <div
          css={css`
            max-width: ${setRem(260, 17)}em;
          `}
        >
          {cont}
        </div>
      );
    } else if (type === 'whirl') {
      padding_str = '0.31em 0.12em 0';
      let cont = text_title_whirl;
      if (titleTextWhirl) {
        cont = titleTextWhirl;
      }
      content_dom = (
        <div
          css={css`
            max-width: ${setRem(276 * scale, 17)}em;
            width: 100%;
            text-align: center;
          `}
        >
          {cont}
        </div>
      );
    } else if (type === 'slide') {
      let cont = slide_tip + (slide_tip ? ':' : '');
      if (titleTextSlide) {
        cont = titleTextSlide + (titleTextSlide ? ':' : '');
      }

      content_dom = (
        <div
          css={css`
            max-width: ${setRem(260, 17)}em;
            white-space: nowrap;
          `}
        >
          {cont}
        </div>
      );
    }
    return (
      <div
        className="captcha_verify_bar"
        css={css`
          position: relative;
          padding: ${padding_str};
          line-height: 0.24em;
          min-height: 0.24em;
        `}
      >
        <CloseButton
          isRTL={isRTL(lang)}
          onClick={handleClose}
          hideCloseBtn={hideCloseBtn}
        />
        <div
          className="captcha_verify_bar--title"
          css={css`
            display: flex;
            align-items: center;
            font-size: ${titleSize
              ? titleSize + '!important'
              : '0.17em !important'};
            color: ${titleColor};
            width: 100%;
            box-sizing: border-box;
          `}
        >
          {content_dom}
        </div>
      </div>
    );
  }
}

export default withTheme(VerifyBar);
